"use client";

import { useRouter } from "next/navigation";
import { useEffect } from "react";

type StrapiPreviewListenerProps = {
	strapiOrigin: string;
};

export function StrapiPreviewListener({
	strapiOrigin,
}: StrapiPreviewListenerProps) {
	const router = useRouter();

	useEffect(() => {
		// Draft mode é um cookie do navegador: fora do iframe do preview do
		// Strapi (navegação normal no site), desativa para voltar ao publicado.
		if (window.self === window.top) {
			fetch("/api/exit-preview").then(() => router.refresh());
			return;
		}

		if (!strapiOrigin) {
			return;
		}

		const handleMessage = (message: MessageEvent) => {
			if (message.origin !== strapiOrigin) {
				return;
			}

			if (message.data?.type === "strapiUpdate") {
				router.refresh();
				return;
			}

			if (message.data?.type === "strapiScript" && message.data.payload?.script) {
				const script = window.document.createElement("script");
				script.textContent = message.data.payload.script;
				window.document.head.appendChild(script);
			}
		};

		window.addEventListener("message", handleMessage);
		window.parent?.postMessage({ type: "previewReady" }, strapiOrigin);

		return () => {
			window.removeEventListener("message", handleMessage);
		};
	}, [router, strapiOrigin]);

	return null;
}
